import { CircularProgress, Dialog, DialogContent, useTheme } from "@mui/material";

import Suspense from "@/components/molecules/Suspense";
import WorkflowActivationForm from "@/components/templates/WorkflowActivationForm";
import { IWorkflow } from "@/interfaces/workflow.interface";
import { WorkflowSaveDialogMessages } from "@/messages/workflow/workflow-save-dialog.messages";

interface WorkflowActivationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  messages: WorkflowSaveDialogMessages;
  workflows?: IWorkflow[] | null;
  isLoading: boolean;
}

export const WorkflowActivationDialog: React.FC<WorkflowActivationDialogProps> = ({
  isOpen,
  onClose,
  messages,
  workflows,
  isLoading,
}) => {
  const {
    margins: { xxxs },
  } = useTheme();

  return (
    <Dialog open={isOpen} onClose={onClose} style={{ padding: xxxs }} fullWidth maxWidth="sm">
      <DialogContent>
        <Suspense isSuspended={!!isLoading} fallback={<CircularProgress size={50} />}>
          <WorkflowActivationForm
            messages={messages}
            onClose={onClose}
            workflows={workflows || []}
          />
        </Suspense>
      </DialogContent>
    </Dialog>
  );
};
